'use strict';

require('es6-shim');

require('./es2016');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/target/es2015.js
// module id = 269
// module chunks = 0